import ROUTE_NAMES from '@/app/admin/router/router-const'

export default [
  {
    path: 'driving-schools',
    name: ROUTE_NAMES.DRIVING_SCHOOLS,
    component: () => import('../DrivingSchoolsPage.vue'),
    meta: {
      perm: 'DRIVING_SCHOOLS'
    },
  },
]